import Rule from "../Rule";

export default class RuleOASetupDateRequiredBeforeMovingToSetup extends Rule {
  static message = "A Setup Date is required before moving to Setup.";

  /**
   * Requires a setup date when moving into Setup, except when resolving a
   * diagnosed issue as Non-billable Approved.
   * @returns {{passed: boolean, message?: string}} Rule evaluation result.
   */
  run() {
    const currentOrderActivity =
      this.currentChartData.orderActivity[this.orderActivityId];
    const futureOrderActivity =
      this.futureChartData.orderActivity[this.orderActivityId];
    const isDiagnoseIssueToNonBillableApproved =
      currentOrderActivity.orderStatusReasonId === 61 &&
      futureOrderActivity.orderStatusReasonId === 56;

    if (
      [0, 1, 2].includes(currentOrderActivity.status) &&
      futureOrderActivity.status === 3 &&
      futureOrderActivity.setupDate === null &&
      !isDiagnoseIssueToNonBillableApproved
    ) {
      return this.fail();
    } else {
      return this.pass();
    }
  }
}
